import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import CtaBanner from "./components/CtaBanner";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Prices from "./pages/Prices";
import Jobs from "./pages/Jobs";
import Settings from "./pages/Settings";
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import FAQ from "./pages/FAQ";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiesPolicy from "./pages/CookiesPolicy";
import ServiceDetail from "./pages/services/ServiceDetail";
import DynamicLocationPage from "./pages/locations/DynamicLocationPage";

/** Same charcoal as the home hero. Used for the header strip and the overscroll canvas. */
const HERO_CANVAS = "#121212";

/** Fills the transparent home header so it sits on the same ground as the hero. */
const HERO_BACKDROP_STYLE = {
  backgroundColor: HERO_CANVAS,
};

function AppShell() {
  const location = useLocation();
  const homeHeroBg = location.pathname === "/";
  const hideGlobalCta = /^\/(dashboard|prices|jobs|settings)/.test(
    location.pathname
  );

  useEffect(() => {
    const root = document.documentElement;
    root.style.backgroundColor = homeHeroBg ? HERO_CANVAS : "";
    return () => {
      root.style.backgroundColor = "";
    };
  }, [homeHeroBg]);

  return (
    <div className="relative flex min-h-screen flex-col bg-white font-sans">
      {homeHeroBg && (
        <div
          aria-hidden
          className="pointer-events-none fixed inset-x-0 top-0 z-0 h-40"
          style={HERO_BACKDROP_STYLE}
        />
      )}
      <div className="relative z-10 flex min-h-screen flex-col">
        <ScrollToTop />
        <Navbar />
        <div className="flex-1 pb-20 md:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/prices" element={<Prices />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/locations/:slug" element={<DynamicLocationPage />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<CookiesPolicy />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        {!hideGlobalCta && <CtaBanner />}
        <Footer />
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
